import type { FilesSortOrder } from "../types/files-filters.types.ts"

// Each page is re-sorted client-side; paging in the list's own order keeps a
// later page from holding rows that belong above the ones already shown.
const NEWEST_FIRST = "-created"

export const documentOrderingFor = (order: FilesSortOrder): string => {
  switch (order) {
    case "name_asc":
      return "file_name"
    case "name_desc":
      return "-file_name"
    case "document_date_desc":
      return "-document_date"
    case "document_date_asc":
      return "document_date"
    default:
      return NEWEST_FIRST
  }
}

// A photo has no date on the paper: the document-date orders place it by its upload.
export const photoOrderingFor = (order: FilesSortOrder): string => {
  switch (order) {
    case "name_asc":
      return "original_filename"
    case "name_desc":
      return "-original_filename"
    case "document_date_asc":
      return "created"
    default:
      return NEWEST_FIRST
  }
}

// Albums have no date on the paper and the API cannot order by file count.
export const albumOrderingFor = (order: FilesSortOrder): string => {
  switch (order) {
    case "name_asc":
      return "name"
    case "name_desc":
      return "-name"
    case "added_desc":
    case "document_date_desc":
      return "-created"
    case "document_date_asc":
      return "created"
    default:
      return "-updated"
  }
}
